import { Component, Input, OnInit } from '@angular/core';
import {
  FormArray,
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { RequiredItemsChecklistService } from '../../subaward/required-items-checklist.service';

@Component({
  selector: 'subs-key-personnel',
  templateUrl: './key-personnel.component.html',
})
export class KeyPersonnelComponent implements OnInit {
  @Input() form: UntypedFormArray;

  constructor(
    private fb: UntypedFormBuilder,
    private checklistService: RequiredItemsChecklistService,
  ) {}

  ngOnInit() {
    this.setKeyPersonnelForm();
    this.form.controls['hasKeyPersonnel'].valueChanges.subscribe((value) => {
      if (value === false) {
        this.form.controls['fullNames'].clear();
        for (let i = 0; i < 3; i++) {
          this.addKeyPersonnel();
        }
        this.form.controls['fullNames'].disable();
      } else {
        this.form.controls['fullNames'].enable();
      }
    });
  }

  setKeyPersonnelForm() {
    if (this.form.controls['hasKeyPersonnel'].value === false) {
      this.form.controls['fullNames'].disable();
    }
  }

  createKeyPersonnelGroup(): FormGroup {
    return this.fb.group({
      fullName: [''],
    });
  }

  addKeyPersonnel() {
    const keyPersonnelForm = this.form.controls;
    const fullNames = keyPersonnelForm['fullNames'];

    fullNames.push(this.createKeyPersonnelGroup());
  }

  removeKeyPersonnel(index: number) {
    const keyPersonnelForm = this.form.controls;
    const fullNames = keyPersonnelForm['fullNames'];

    fullNames.removeAt(index);
  }
}
